import classes from "./styles.module.scss";
import clsx from "classnames";
import { useEffect, useRef } from "react";
import { useIsVisible } from "@/hooks/useIsVisible";

/**
 * Section heading with a rule that draws itself while the heading is in view.
 *
 * @param {Object} props
 * @returns {JSX.Element}
 */
export const Heading = ({ className, children, variant }) => {
  const [visible, visibilityRef] = useIsVisible({ partial: true });
  const contentRef = useRef();
  const ruleRef = useRef();

  useEffect(() => {
    if (contentRef.current && "getBoundingClientRect" in contentRef.current) {
      const rect = contentRef.current.getBoundingClientRect();
      const panelWidth = rect.width + rect.x;
      ruleRef.current.style.width = `${visible ? panelWidth : 0}px`;
    }
  }, [visible]);

  return (
    <div ref={visibilityRef} className={clsx(className, classes.heading, variant)}>
      <div ref={contentRef} className="d-inline-block position-relative">
        {children}
        <span ref={ruleRef} className={classes.heading__rule} />
      </div>
    </div>
  );
};

Heading.defaultProps = {
  variant: "primary",
  className: "mb-0 mb-md-4",
  containerClassName: "px-0",
};
